module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm('personEdit')
      }
    }
  }, [_c('action-buttons', {
    staticClass: "pull-right",
    attrs: {
      "disable-next": true,
      "disable-previous": true,
      "disable-delete": true
    },
    on: {
      "save-and-back": _vm.submitFormAndBack,
      "save-and-new": _vm.submitFormAndNew,
      "back": _vm.goBack
    }
  }), _vm._v(" "), (_vm.mode == 'edit') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Persoon aanpassen")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Persoon toevoegen")]) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.mode == 'edit') ? _c('h2', [_vm._v(_vm._s((_vm.form.last_name_prefix) ? ((_vm.form.first_name) + " " + (_vm.form.last_name_prefix) + " " + (_vm.form.last_name)) : ((_vm.form.first_name) + " " + (_vm.form.last_name))))]) : _vm._e(), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), (!_vm.isFetching) ? _c('div', [(_vm.formError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('person-form-fields', {
    attrs: {
      "hide-admin": false,
      "form": _vm.form,
      "countryList": _vm.countryList,
      "mode": _vm.mode
    },
    on: {
      "update:form": function($event) {
        _vm.form = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('b-jumbotron', {
    staticClass: "py-4"
  }, [_c('h3', [_vm._v("Biednummers")]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Vast biednummer:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.fixed_bid_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "fixed_bid_number", $$v)
      },
      expression: "form.fixed_bid_number"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("Biednummers per veiling")]), _vm._v(" "), (_vm.mode == 'edit') ? _c('div', [_c('bid-numbers')], 1) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSla de persoon op om biednummers toe te voegen.\n\t\t\t\t\t\t\t\t"), _c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('personEdit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  }), _vm._v(" Sla direct op")])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-jumbotron', {
    staticClass: "py-4"
  }, [_c('h3', [_vm._v("E-maillogs")]), _vm._v(" "), _c('email-logs-component', {
    attrs: {
      "isFetching": _vm.isFetching,
      "logs": _vm.person.email_logs
    }
  })], 1)], 1)])], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13373ea0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Person/Form/PersonForm.vue
// module id = 1280
// module chunks = 1